<template>
  <div class="residents" v-if="residentData.elegibility_codes">
    <dropdown ref="dropdown"
              @open="$store.dispatch('notifyOverflowToParent', true)"
              @close="close"
    >
      <div slot="link"
        class="inputText --tag --sm --caret" >
        <div class="inputText__group">
          <input
              readonly
              @keydown.enter="$refs.dropdown.toggleDropdown()"
              class="inputText__input"
              type="text"
              :value="elegibilityPlaceholder"
              aria-label="Promo Code"
              aria-describedby="Promo Code"
              tabindex="0"
              name="Promo Code"
          >
        </div>
      </div>
      <div slot="content" class="residents__dropdown surface">
        <div class="residents__message">
          <i class="fas fa-info-circle mr-2"></i>
          <span class="residents__messageText"> {{$t('resident_or_large_family_message_text')}}</span>
        </div>
        <div class="residents__list">
          <div class="codes" v-for="(elegibility_code, index) in residentData.elegibility_codes" :key="index">
            <span class="residents__listTitle">{{ $t(elegibility_code.label) }}</span>
            <div class="inputRadio" v-for="(option, index) in elegibility_code.options" :key="index">
              <label class="inputRadio__container">
                <input type="radio"
                      :id="option.value"
                      :value="option"
                      :name="option.value" 
                      class="inputRadio__input"
                      v-model="$data[elegibility_code.label]"
                      v-on:change="residentOrNumerousFamilyChange()"
                      >
                <span class="inputRadio__checkmark"></span>
                <span class="inputRadio__label">{{ $t(option.label) }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </dropdown>
  </div>
</template>
<script>
  import Dropdown from '../Dropdown'
  export default {
    name: 'Residents',
    components: {
      Dropdown
    },
    props: {
      residentData: {
        required: true,
        type: Object
      },
      elegibilityValues: {
        required: true,
        type: Array
      }
    },
    methods: {
      close: function () {
        this.$store.dispatch('notifyOverflowToParent', false)
        this.$refs.dropdown.show = false
      },
      residentOrNumerousFamilyChange: function () {
        this.$emit('residentOrNumerousFamilyChange', {
          resident: this.elegibility_resident.value,
          numerousFamily: this.elegibility_numerous_family.value,
          documentsFiltered: this.documentsFiltered
        })
      }
    },
    data () {
      return {
        elegibility_resident: { value: '' },
        elegibility_numerous_family: { value: '' }
      }
    },
    watch: {
      residentData: function () {
        if (this.elegibilityValues && this.elegibilityValues.length > 0) {
          this.residentData.elegibility_codes?.forEach((elegibilityCode, index) => {
            let selectedValue = this.elegibilityValues.find(option => option.label == elegibilityCode.label)?.value
            this.$data[elegibilityCode.label] = elegibilityCode.options.find(option => option.value == selectedValue)
          })
        } else {
          this.residentData.elegibility_codes?.forEach((elegibilityCode, index) => {
            this.$data[elegibilityCode.label] = elegibilityCode.options.find(option => option.default)
          })
        }
        this.residentOrNumerousFamilyChange()
      }
    },
    mounted () {
      this.residentOrNumerousFamilyChange()
    },
    computed: {
      elegibilityPlaceholder () {
        if (this.elegibility_numerous_family && this.elegibility_resident) 
          return this.residentData.elegibility_codes.map((code) =>
            this.$i18n.t(this.$data[code.label].label)
          ).join(' | ')
        if (this.elegibility_numerous_family)
          return this.$i18n.t(this.elegibility_numerous_family.label)
        if (this.elegibility_resident)
          return this.$i18n.t(this.elegibility_resident.label)
      },
      documentsFiltered () {
        let documentsToGetIntersection = [
          this.elegibility_resident,
          this.elegibility_numerous_family
        ].filter(elegibilityItem => elegibilityItem.value != '')
        .map(elegibility => elegibility.restricted_documents_list)

        let documentIntersection = documentsToGetIntersection.length !== 0 ? documentsToGetIntersection.reduce(
          (acummulator, currentItem)  => acummulator.filter(value => currentItem.includes(value))
        ) : []
        
        return documentIntersection
      }
    }
  }
</script>
<style lang="sass">
.residents
  &__dropdown
    position: absolute
    padding: 1rem
    z-index: var(--z-1)
    top: -1rem
    min-width: 300px
  &__message
    display: flex
    align-items: baseline
    margin-bottom: .5rem
    padding: .5rem
    font-size: var(--font-size-sm)
    background-color: var(--color-overlay-05)
    border-radius: var(--b-radius-sm)
  &__list
    .inputRadio:last-child
      margin-bottom: 0
  &__listTitle
    display: flex
    margin: 1rem 0 .5rem
    font-weight: bolder
    font-size: var(--font-size-sm)
</style>